import React from "react";
import "./partners-slider.scss";
import Standard from "../../assets/images/standard.png";
import Switch from "../../assets/images/switch.png";

import Aisa from "../../assets/images/aisa.svg";
import Grange from "../../assets/images/grange.png";
import LBS from "../../assets/images/lbs.png";
import Cobis from "../../assets/images/cobis.png";

import Starvile from "../../assets/images/starvile.png";
import Spring from "../../assets/images/spring.png";
import Bereton from "../../assets/images/bereton.png";
import Wellspring from "../../assets/images/wellspring.png";
import Jewel from "../../assets/images/jewel.png";
import Charlse from "../../assets/images/charlse.png";
import Green from "../../assets/images/green.png";
import Meadow from "../../assets/images/meadow.png";
import Danbo from "../../assets/images/danbo.png";
import Maryland from "../../assets/images/maryland.png";
import MIS from "../../assets/images/mis.png";
import Lagoon from "../../assets/images/lagoon.png";
import Evergreen from "../../assets/images/evergreen.png";
import Royal from "../../assets/images/royal.png";
import Crescent from "../../assets/images/crescent.png";
import Norwegian from "../../assets/images/norwagian.png";
import British from "../../assets/images/british.png";
import Doveland from "../../assets/images/doveland.png";
import Apostolic from "../../assets/images/apostolic.png";
import Noble from "../../assets/images/noble.png";
import Graceland from "../../assets/images/graceland.png";
import MD from "../../assets/images/md.png";
import Mont from "../../assets/images/mis.png";
import bloombreed from "../../assets/images/add-bloombreed.png";
import jamesHope from "../../assets/images/add-james-hope-college.png";
function PartnersSlider() {
  return (
    <div>
      <div className="col-md-12 partners-slider mt ">
        <center className="mb5">
          {" "}
          <h3>Trusted by leading organizations</h3>
        </center>
        <div className="slider mt">
          <div className="slide-track partners-immgs">
            {" "}
            <img className="standard slide" src={Standard} alt="Scholar" />
            <img className="cobis slide" src={Cobis} alt="Scholar" />{" "}
            <img className="aisa slide" src={Aisa} alt="Scholar" />{" "}
            <img className="grange slide" src={Grange} alt="Scholar" />{" "}
            <img className="lbs slide" src={LBS} alt="Scholar" />{" "}
            <img className="starvile slide" src={Starvile} alt="Scholar" />{" "}
            <img className="switch-app slide " src={Switch} alt="Scholar" />{" "}
            <img className="standard slide" src={Standard} alt="Scholar" />
            <img className="cobis slide" src={Cobis} alt="Scholar" />{" "}
            <img className="aisa slide" src={Aisa} alt="Scholar" />{" "}
            <img className="grange slide" src={Grange} alt="Scholar" />{" "}
            <img className="lbs slide" src={LBS} alt="Scholar" />{" "}
            <img className="starvile slide" src={Starvile} alt="Scholar" />{" "}
            <img className="switch-app slide" src={Switch} alt="Scholar" />{" "}
            <img className="standard slide" src={Standard} alt="Scholar" />
            <img className="cobis slide" src={Cobis} alt="Scholar" />{" "}
            <img className="aisa slide" src={Aisa} alt="Scholar" />{" "}
            <img className="grange slide" src={Grange} alt="Scholar" />{" "}
            <img className="lbs slide" src={LBS} alt="Scholar" />{" "}
            <img className="starvile slide" src={Starvile} alt="Scholar" />{" "}
            <img className="switch slide " src={Switch} alt="Scholar" />{" "}
            <img className="bloombreed slide" src={bloombreed} alt="Bloombreed logo" />{" "}
            <img className="jamesHope slide" src={jamesHope} alt="James Hope College logo" />{" "}
          </div>
        </div>
        <div className="slider ">
          <div className="slide-track2 partners-immgs">
            {" "}
            <img className="bereton slide" src={Bereton} alt="Scholar" />
            <img
              className="wellspring slide"
              src={Wellspring}
              alt="Scholar"
            />{" "}
            <img
              className="jewel slide"
              src={Jewel}
              alt="Scholar"
            />{" "}
            <img className="charlse slide" src={Charlse} alt="Scholar" />{" "}
            <img className="green slide" src={Green} alt="Scholar" />{" "}
            <img className="meadow slide" src={Meadow} alt="Scholar" />{" "}
            <img className="lagoon slide" src={Lagoon} alt="Scholar" />{" "}
            <img className="spring slide " src={Spring} alt="Scholar" />{" "}
            <img className="evergreen slide" src={Evergreen} alt="Scholar" />
            <img className="danbo slide" src={Danbo} alt="Scholar" />{" "}
            <img className="royal slide" src={Royal} alt="Scholar" />{" "}
            <img className="bereton slide" src={Bereton} alt="Scholar" />
            <img
              className="wellspring slide"
              src={Wellspring}
              alt="Scholar"
            />{" "}
            <img
                className="jewel slide"
                src={Jewel}
                alt="Scholar"
            />{" "}
            <img className="charlse slide" src={Charlse} alt="Scholar" />{" "}
            <img className="green slide" src={Green} alt="Scholar" />{" "}
            <img className="meadow slide" src={Meadow} alt="Scholar" />{" "}
            <img className="lagoon slide" src={Lagoon} alt="Scholar" />{" "}
            <img className="bloombreed slide" src={bloombreed} alt="Bloombreed logo" />{" "}
            <img className="jamesHope slide" src={jamesHope} alt="James Hope College logo" />{" "}
            <img className="spring slide " src={Spring} alt="Scholar" />{" "}
            <img className="evergreen slide" src={Evergreen} alt="Scholar" />
            <img className="danbo slide" src={Danbo} alt="Scholar" />{" "}
            <img className="royal slide" src={Royal} alt="Scholar" />{" "}
          </div>
        </div>
        <div className="slider ">
          <div className="slide-track3 partners-immgs">
            {" "}
            <img className="crescent slide" src={Crescent} alt="Scholar" />
            <img className="bloombreed slide" src={bloombreed} alt="Bloombreed logo" />{" "}
            <img className="jamesHope slide" src={jamesHope} alt="James Hope College logo" />{" "}
            <img
              className="norwegian slide"
              src={Norwegian}
              alt="Scholar"
            />{" "}
            <img className="british slide" src={British} alt="Scholar" />{" "}
            <img className="doveland slide" src={Doveland} alt="Scholar" />{" "}
            <img className="apostolic slide" src={Apostolic} alt="Scholar" />{" "}
            <img className="noble slide" src={Noble} alt="Scholar" />{" "}
            <img className="graceland slide " src={Graceland} alt="Scholar" />{" "}
            <img className="md slide" src={MD} alt="Scholar" />
            <img className="mis slide" src={MIS} alt="Scholar" />{" "}
            <img className="crescent slide" src={Crescent} alt="Scholar" />
            <img
              className="norwegian slide"
              src={Norwegian}
              alt="Scholar"
            />{" "}
            <img className="british slide" src={British} alt="Scholar" />{" "}
            <img className="doveland slide" src={Doveland} alt="Scholar" />{" "}
            <img className="apostolic slide" src={Apostolic} alt="Scholar" />{" "}
            <img className="noble slide" src={Noble} alt="Scholar" />{" "}
            <img className="graceland slide " src={Graceland} alt="Scholar" />{" "}
            <img className="md slide" src={MD} alt="Scholar" />
            <img className="mis slide" src={MIS} alt="Scholar" />{" "}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnersSlider;
